<div class='poam-component' style='height: 100%' *ngIf="project">
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div style="display: flex; flex-direction: row; justify-content: space-between; flex:1 1 auto">
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin: 10px 10px 10px 10px">Project
        Name: {{project.name}}</h2>
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin: 10px 10px 10px 10px;">
        Generated: {{date | date : 'MM/dd/yyyy hh:mm aa'}}</h2>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 6px;margin-bottom: 10px;align-items:center;">
      <button mat-raised-button
              style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
              class="button" [routerLink]="['/projects', 'project', projectId]">
        Back to project
      </button>
    </div>
  </div>

  <p-table [value]="items"
           #poamTable
           [style]="{'font-size': '0.8em'}"
           [rows]="100"
           [reorderableColumns]="true"
           [paginator]="true"
           [pageLinks]="3"
           [rowsPerPageOptions]="[10, 20, 50, 100]"
           [resizableColumns]="true"
           [metaKeySelection]="false"
           exportFilename="CidReport"
           [columns]="cols">

    <ng-template pTemplate="caption">
      <div class="ui-helper-clearfix flex flex-row justify-content-end">
        <button type="button"
                pButton
                class="risksponge-button"
                icon="pi pi-file-excel"
                iconPos="left"
                (click)="poamTable.exportCSV()">
        </button>
        <div style="float: right;">
          <p-multiSelect [options]="columnOptions"
                         [(ngModel)]="cols"
                         (onChange)="onPanelHide()">
            <ng-template let-value pTemplate="selectedItems">
              {{columnOptions.length}} items selected
            </ng-template>
          </p-multiSelect>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
        <th *ngFor="let col of cols" [pSortableColumn]="col.field" pResizableColumn
            [ngStyle]="{'width': col.width || 'auto'}" style="font-weight: bold; text-align: center;">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
      </tr>
      <!--tr>
        <th *ngFor="let col of cols" [ngSwitch]="col.field">
          <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                 (input)="poamTable.filter($event.target['value'], col.field, 'contains')">
          <span *ngSwitchCase="'dueDate'"></span>
        </th>

      </tr-->
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
      <tr [pSelectableRow]="item">
        <td *ngFor="let col of cols" [ngSwitch]="col.field">
          <span *ngSwitchDefault>{{item[col.field]}}</span>
          <span *ngSwitchCase="'description'">
            {{item.description.length > 60 ? item.description.substring(0, 60) + '...' : item.description}}
          </span>
          <span *ngSwitchCase="'implementationStatus'" style="display: block; text-align: center;">
            {{implementationStatuses[item.implementationStatus]}}
          </span>
          <span *ngSwitchCase="'icsLastUpdated'" style="display: block; text-align: center;">
            <ng-container *ngIf="item.icsLastUpdated">
              {{item.icsLastUpdated | date : 'MM/dd/yyyy'}}
            </ng-container>
            <ng-container *ngIf="!item.icsLastUpdated">-</ng-container>
          </span>
          <span *ngSwitchCase="'evidencesText'">
            <ul>
            <li *ngFor="let evidence of item.evidences">
              {{evidence.date | date : 'MM/dd/yyyy'}} -
              <span
                *ngIf="!evidence.name?.startsWith('http://') && !evidence.name?.startsWith('https://') && !evidence.name?.startsWith('\\\\')"
                (click)="DownloadEvidence(item, evidence.name)">{{evidence.name}}</span>
              <a
                *ngIf="evidence.name?.startsWith('http://') || evidence.name?.startsWith('https://') || evidence.name?.startsWith('\\\\')"
                [attr.href]="evidence.name" target="_blank">{{evidence.name}}</a>
            </li>
              </ul>
          </span>
          <span *ngSwitchCase="'policiesText'">
            <ul style="padding-left: 2em">
            <li *ngFor="let policy of item.policies">
              {{policy}}
            </li>
            </ul>
          </span>
          <span *ngSwitchCase="'openPoamsText'">
            <ul style="padding-left: 2em">
            <li *ngFor="let actionPlan of item.openPoams">
              {{actionItemStatuses[actionPlan.currentStatus]}} {{actionPlan.riskLevel}}
              <br/>
              {{actionPlan.weaknessDescription.length > 60 ? actionPlan.weaknessDescription.substring(0, 60) + '...' : actionPlan.weaknessDescription}}
              - {{actionPlan.scheduledCompletionDate | date : 'MM/dd/yyyy'}}
            </li>
              </ul>
          </span>
          <span *ngSwitchCase="'completionsText'">
            <div *ngFor="let completion of item.completions">{{completion.dueDate | date : 'shortDate'}}
              - {{completion.isCompleted ? 'Completed' : 'Not Completed'}} {{completion.modified ? 'Updated:' + (completion.modified | date : 'shortDate') : ''}}</div>
          </span>
          <span *ngSwitchCase="'dependencyListText'">
            <div *ngFor="let dependency of item.dependencyList">{{dependency.projectName}} - {{dependency.controlItem.category}}/{{dependency.controlItem.complianceAreaControlId}}</div>
          </span>
        </td>
      </tr>
    </ng-template>


  </p-table>
</div>
